export enum ActionTypes {
  GetExpertServicesImplementation = 'getExpertServicesImplementation',
  GetExpertServicesImplementationRequest = 'getExpertServicesImplementation.request',
  GetExpertServicesImplementationSuccess = 'getExpertServicesImplementation.success',
  GetExpertServicesImplementationFailure = 'getExpertServicesImplementation.failure',
}
